import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { IconifyComponent } from '../standalone-components/iconography/iconify/iconify.component';
import { LoadingIconComponent } from '../standalone-components/loaders/loading-icon/loading-icon.component';
import { SpinnerComponent } from '../standalone-components/loaders/spinner/spinner.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PipesModule,
    IconifyComponent,
    LoadingIconComponent,
    SpinnerComponent,
  ],
  exports: [
    PipesModule,
    IconifyComponent,
    LoadingIconComponent,
    SpinnerComponent,
  ],
})
export class SharedComponentsModule {}
